import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import { autobind, throttle } from 'core-decorators'
import { getScrollTop, scrollTo } from '../../util/scrolling'
import css, { boostDuration } from './flying-dude.css'

const HIDE_DELAY = 2000
const MAX_FLY_DURATION = 3000

export default class extends Component {
    static propTypes = {
        align: PropTypes.string,
        label: PropTypes.string.isRequired,
        scrollSelector: PropTypes.string,
        isActive: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        isMobile: PropTypes.bool,
    }

    static defaultProps = {
        align: 'center',
    }

    state = {
        isFixed: false,
        isHidden: false,
        isScrolling: false,
    }

    scrollEl = null
    offsetTop = 0
    previousScroll = 0
    hideDelay = null

    componentDidMount() {
        const { scrollSelector } = this.props

        // events
        if (scrollSelector) {
            this.scrollEl = document.querySelector(scrollSelector)
            this.scrollEl.addEventListener('scroll', this.onScroll)
        } else {
            window.addEventListener('scroll', this.onScroll)
        }

        const scrollTop = this.scrollEl ? this.scrollEl.scrollTop : getScrollTop()
        this.offsetTop = this.el.getBoundingClientRect().top + scrollTop

        // update position
        this.onScroll()
    }

    componentWillUnmount() {
        clearTimeout(this.hideDelay)
        if (this.scrollEl) {
            this.scrollEl.removeEventListener('scroll', this.onScroll)
        } else {
            window.removeEventListener('scroll', this.onScroll)
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.isActive !== this.props.isActive) {
            return true
        }
        if (nextProps.label !== this.props.label) {
            return true
        }
        if (nextState.isFixed !== this.state.isFixed) {
            return true
        }
        if (nextState.isHidden !== this.state.isHidden) {
            return true
        }
        if (nextState.isScrolling !== this.state.isScrolling) {
            return true
        }
        return false
    }

    @autobind
    @throttle(30)
    onScroll() {
        const scroll = this.scrollEl ? this.scrollEl.scrollTop : getScrollTop()
        const isFixed = scroll > this.offsetTop
        this.setState({
            isFixed: scroll > this.offsetTop,
            isHidden: isFixed ? scroll > this.previousScroll : false,
        })

        this.previousScroll = scroll

        // delay hiding
        clearTimeout(this.hideDelay)
        this.hideDelay = setTimeout(() => this.setState({ isHidden: false }), HIDE_DELAY)
    }

    @autobind
    onClick() {
        const { onClick } = this.props
        const { isFixed } = this.state
        const scroll = this.scrollEl ? this.scrollEl.scrollTop : getScrollTop()
        const delay = parseFloat(boostDuration)
        const scrollDuration = Math.min(scroll / 1000, 2) * 300

        if (!isFixed) {
            onClick()
            return
        }

        this.setState({ isScrolling: true })

        setTimeout(() => {
            const scrollTop = this.offsetTop - this.el.offsetHeight
            scrollTo(this.scrollEl, scrollTop, Math.min(scrollDuration, MAX_FLY_DURATION)).then(() => {
                this.setState({ isScrolling: false })
                onClick()
            })
        }, delay * 900)
    }

    render() {
        const { label, isActive, isMobile } = this.props
        const { isFixed, isHidden, isScrolling } = this.state
        const dudeClass = isHidden ? css.dudeHidden : css.dudeIdle
        let wrapperClass = css.wrapper
        let boostClass = isMobile ? css.dudeBoost : css.dudeBoostDesktop
        if (isFixed) {
            if (isMobile) {
                wrapperClass = isHidden && !isScrolling ? css.wrapperHidden : css.wrapperFixed
            } else {
                wrapperClass = isHidden && !isScrolling ? css.wrapperHiddenDesktop : css.wrapperFixedDesktop
            }
        }
        return (
            <div className={isActive ? css.container : css.containerHidden} ref={c => (this.el = c)}>
                <div className={wrapperClass}>
                    <div className={isScrolling ? boostClass : dudeClass}>
                        <span className={css.label} onClick={this.onClick}>
                            {label}
                        </span>
                        <div className={isScrolling ? css.wingLeftBoost : css.wingLeft} />
                        <div className={isScrolling ? css.wingRightBoost : css.wingRight} />
                    </div>
                </div>
            </div>
        )
    }
}
